import { makeStyles } from '@material-ui/core/styles';
const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
    mainContainer: {
        backgroundColor: '#1F6E5E'
    },
    input: {
        margin: theme.spacing.unit,
    },
    primaryContainer: {
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "20px",
        width: "70%",
        maxWidth: "800px"
    },
    formSectionTitle:{
        display: "flex",
        justifyContent: "center",
        padding: "10px",
        fontSize: "18px",
        fontWeight: "600",
        borderBottom: "1px solid #f0f0f0",
        marginBottom: "10px",
        color: "#1f6e5e"
    },
    form_container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: '#fff',
    },
    text_container: {
        display: 'flex',
        marginBottom: '1rem',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        width : "45%",
        maxWidth : "450px",
        marginLeft: 20,
        marginRight: 20
    },
    DealerSpecialist: {
        display: 'flex',
        marginTop: '60',
        marginLeft: 120
    },
    containerRight: {
        flexDirection: 'column',
        marginLeft: 150,
        marginTop: 0,
        paddingTop: '2px'
    },
    containerLeft: {
        flexDirection: 'column',
        marginRight: 150
    },
    container: {
        flexDirection: 'row',
        display: 'flex',
        paddingTop: 50
    },
    textField: {
        width: "90%",
        height: 0,
        paddingBottom: 20,
        marginRight: 0,
        outline: 'none',
        border: 'none',
        background: 'transparent',
        boxShadow: 'none'
    },
    contact_input: {
        width: 190,
        paddingTop: 15,
    },
    contactPerson: {
        width: 200,
        paddingTop: 14
    },
    root: {
        '& > *': {
            margin: theme.spacing(1)
        },
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: '#fff',
        justifyContent: 'center',
    },
    title: {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: '#fff',
    },
    margin: {
        margin: theme.spacing(1),
    },
    appTitle: {
        color: '#194F42',
        fontWeight: '600',
        fontSize: 25,
        flexDirection: 'column'
    },
    flex: {
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: '#FFFFFF',
        flexDirection: 'row',
        marginTop: '1%',
        maxheight: 50,
    },
    flexPrimary: {
        width: '100%',
        display: 'flex',
        background: '#f0f0f0',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: 50,
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
    },
}));

export default useStyles;